"use strict";
/**
 * @packageDocumentation @module Messages
 */
Object.defineProperty(exports, "__esModule", { value: true });
var sendMessage_1 = require("./sendMessage");
Object.defineProperty(exports, "sendMessage", { enumerable: true, get: function () { return sendMessage_1.sendMessage; } });
var sendReadStatus_1 = require("./sendReadStatus");
Object.defineProperty(exports, "sendReadStatus", { enumerable: true, get: function () { return sendReadStatus_1.sendReadStatus; } });
var sendDeliveredStatus_1 = require("./sendDeliveredStatus");
Object.defineProperty(exports, "sendDeliveredStatus", { enumerable: true, get: function () { return sendDeliveredStatus_1.sendDeliveredStatus; } });
var deleteMessage_1 = require("./deleteMessage");
Object.defineProperty(exports, "deleteMessage", { enumerable: true, get: function () { return deleteMessage_1.deleteMessage; } });
var useByDialog_1 = require("./useByDialog");
Object.defineProperty(exports, "useByDialog", { enumerable: true, get: function () { return useByDialog_1.useByDialog; } });
var useMessages_1 = require("./useMessages");
Object.defineProperty(exports, "useMessages", { enumerable: true, get: function () { return useMessages_1.useMessages; } });
var useMessage_1 = require("./useMessage");
Object.defineProperty(exports, "useMessage", { enumerable: true, get: function () { return useMessage_1.useMessage; } });
var onNewMessage_1 = require("./onNewMessage");
Object.defineProperty(exports, "onNewMessage", { enumerable: true, get: function () { return onNewMessage_1.onNewMessage; } });
var onMessageError_1 = require("./onMessageError");
Object.defineProperty(exports, "onMessageError", { enumerable: true, get: function () { return onMessageError_1.onMessageError; } });
var onSendMessage_1 = require("./onSendMessage");
Object.defineProperty(exports, "onSendMessage", { enumerable: true, get: function () { return onSendMessage_1.onSendMessage; } });
//# sourceMappingURL=index.js.map